export default {
  date: 'August 27, 2024',
  title: 'Update: New style "Japandi"',
  description: 'Discover the new style – harmony of minimalism and comfort!',
  id: 'japandi-style',
  jsx: () => (
    <div class='novelty__text'>
      <p>Discover the new style – harmony of minimalism and comfort!</p>
      <p>
        We are excited to introduce our new style in 3D visualizations —<b> "Japandi"</b>. This unique blend of Japanese minimalism and Scandinavian functionality will not only transform your interior but also turn it into a true oasis of calm and warmth.
      </p>
      <b>Why "Japandi"?</b>
      <p>
        This style is winning hearts worldwide with its ability to combine simplicity and coziness. Clean lines, neutral colors, and natural materials create a space that is easy to live in, breathe in, and most importantly, sell. "Japandi" is not just beautiful — it helps buyers see the full charm
        and potential of your property.
      </p>
      <b>Ready to try it?</b>
      <p>You can now choose the "Japandi" style when ordering 3D visualizations on our website. Add elegance and warmth to your projects, and let buyers fall in love with your interior at first sight.</p>
      <b>How to Order?</b>
      <p class='margin-none'>
        <b>Step 1. </b>
        Visit the storefront section at
        <a href='https://getfloorplan.com'> getfloorplan.com</a>
      </p>
      <p class='margin-none'>
        <b>Step 2. </b>
        Click the “Place an order” button on any 3D product card.
      </p>
      <p>
        <b>Step 3. </b>
        On the second step of the “AI set-up” process, select the “Japandi” interior style under the “Select interior style” heading.
      </p>
      <p>This style not only meets the modern buyer’s expectations but also helps boost sales by offering a unique yet versatile design. Sell properties faster with Getfloorplan.</p>
    </div>
  ),
  thumb: 'news/28.webp',
};
